import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { h } from "@vue/composition-api";
import { defineComponent } from 'vue-demi';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
var BaseChart = defineComponent({
  inheritAttrs: false,
  name: 'BaseChart',
  mounted: function mounted() {
    var _ref = this.$attrs,
        Chart = _ref.chart;

    var _this$getChartConfig = this.getChartConfig(),
        data = _this$getChartConfig.data,
        config = _this$getChartConfig.config;

    this.config = cloneDeep(config);
    var normalizedData = data || [];
    this.data = normalizedData;
    this.plot = new Chart(this.$el, _objectSpread({
      data: normalizedData
    }, config));
    this.plot.render();
  },
  beforeUpdate: function beforeUpdate() {
    var _this$getChartConfig2 = this.getChartConfig(),
        data = _this$getChartConfig2.data,
        config = _this$getChartConfig2.config;

    var normalizedData = data || [];
    /* istanbul ignore else */

    if (this.plot) {
      if (!isEqual(config, this.config) || !this.data.length) {
        this.config = cloneDeep(config);
        this.plot.update(_objectSpread({
          data: normalizedData
        }, config));
        this.plot.render();
      } else {
        this.plot.changeData(normalizedData);
      }

      this.data = normalizedData;
    }
  },
  beforeUnmount: function beforeUnmount() {
    /* istanbul ignore else */
    if (this.plot) {
      this.plot.destroy();
    }
  },
  methods: {
    getChartConfig: function getChartConfig() {
      var _ref2 = this.$attrs,
          chart = _ref2.chart,
          chartRef = _ref2.chartRef,
          restProps = _objectWithoutProperties(_ref2, ["chart", "chartRef"]);

      var data = restProps.data,
          config = _objectWithoutProperties(restProps, ["data"]);

      return {
        data: data,
        config: config
      };
    }
  },
  render: function render() {
    return h("div");
  }
});
export default BaseChart;